var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBares({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 62,
    viewBox: "0 0 54 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1259_2251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3093 59.7876H41.4738",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8916 36.4126V59.7876",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8916 11.6965H52.0066L41.9526 24.9486L31.8916 37.0177L21.8375 24.9486L11.7834 11.6965H31.8916Z",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2511 19.7358C15.6899 20.7812 13.8095 21.3932 11.7835 21.3932C6.37827 21.3932 2 17.0538 2 11.6966C2 6.3394 6.37827 2 11.7835 2C17.1886 2 21.5669 6.3394 21.5669 11.6966",
    stroke: "#FF6600",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1259_2251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 62,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBares);
export default __webpack_public_path__ + "static/media/bares.2aa71eec03054118d5ab86b1e41cbf5f.svg";
export { ForwardRef as ReactComponent };